import React, { CSSProperties } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';

interface EstimatePlusIconProps {
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const iconStyle: CSSProperties = {
  position: 'relative',
  paddingLeft: '5px',
};

const iconPlusStyle: CSSProperties = {
  position: 'absolute',
  top: '8px',
  left: '-5px',
  fontSize: '10px',
};

const EstimatePlusIcon: React.FC<EstimatePlusIconProps> = ({
  onClick,
  className = '',
  style = {},
}) => (
  <div
    style={{ ...iconStyle, ...style }}
    className={`${className}`}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={faFileInvoiceDollar} />
    <FontAwesomeIcon icon={faPlus} style={iconPlusStyle} />
  </div>
);

export default EstimatePlusIcon;
